module.exports = __webpack_public_path__ + "static/logo_new.9f5d47be.jpg";